import { Stack, Skeleton, Box } from "@mui/material";

const LoadingSkeleton = () => {
  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Fixed Top Navigation Bar */}
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 64,
          bgcolor: "white",
          boxShadow: "0 1px 12px rgba(89, 89, 89, 0.42)",
          zIndex: 1100,
          display: "flex",
          alignItems: "center",
          px: 2,
        }}
      >
        <Skeleton variant="rectangular" width={120} height={32} sx={{boxShadow: "0 1px 12px rgba(89, 89, 89, 0.42)",}} />
        <Box sx={{ flexGrow: 1 ,boxShadow: "0 1px 12px rgba(89, 89, 89, 0.42)",}} />
        <Stack direction="row" spacing={2}>
          <Skeleton variant="circular" width={40} height={40} sx={{boxShadow: "0 1px 12px rgba(89, 89, 89, 0.42)",}} />
          <Skeleton variant="circular" width={40} height={40} sx={{boxShadow: "0 1px 12px rgba(89, 89, 89, 0.42)",}} />
        </Stack>
      </Box>

      {/* Main Content Area with only 4 boxes */}
      <Box
        sx={{
          flex: 1,
          overflow: "auto",
          pt: 8, // Account for top nav
          pb: 8, // Account for bottom nav
          px: 2,
          boxShadow: "0 1px 12px rgba(89, 89, 89, 0.42)",
        }}
      >
        <Stack spacing={3} sx={{ mt: 2 }}>
          {/* Box 1 */}
          <Skeleton 
            variant="rectangular" 
            height={100} 
            sx={{ borderRadius: 2,boxShadow: "0 1px 12px rgba(89, 89, 89, 0.42)", }} 
          />
          
          {/* Box 2 */}
          <Skeleton 
            variant="rectangular" 
            height={100} 
            sx={{ borderRadius: 2,boxShadow: "0 1px 12px rgba(89, 89, 89, 0.42)", }} 
          />
          
          {/* Box 3 */}
          <Skeleton 
            variant="rectangular" 
            height={100} 
            sx={{ borderRadius: 2,boxShadow: "0 1px 12px rgba(89, 89, 89, 0.42)", }} 
          />
          
          {/* Box 4 */}
          <Skeleton 
            variant="rectangular" 
            height={100} 
            sx={{ borderRadius: 2,boxShadow: "0 1px 12px rgba(89, 89, 89, 0.42)", }} 
          />
        </Stack>
      </Box>

      {/* Fixed Bottom Navigation Bar */}
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          height: 56,
          bgcolor: "white",
         boxShadow: "0 1px 12px rgba(89, 89, 89, 0.42)",
          zIndex: 1100,
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          px: 2,

        }}
      >
        {[1, 2, 3, 4].map((item) => (
          <Box key={item} sx={{ display: "flex", flexDirection: "column", alignItems: "center"}}>
            <Skeleton variant="circular" width={24} height={24} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default LoadingSkeleton;